import { NodeMapChange } from '../pages/mindmap/use-mindmap-history';

export type TextBlock = {
  type: 'dynamic' | 'static';
  text: string;
  textDecoration?: string;
  fontStyle?: string;
};

export type MapChangeDescription = {
  icon: string;
  descriptions: {
    text: string;
    preview?: TextBlock[];
    details?: {
      name: string;
      value?: string | null;
    }[];
  }[];
};

export const getMapChangeDescription = (mapChange: NodeMapChange) => {
  let { addedNodes, deletedNodes, updatedNodes } = mapChange;
  let mapChangeDescription: MapChangeDescription = {
    icon: '',
    descriptions: [],
  };

  // remove any added nodes of which their parents are also added at this node map change
  // (e.g. when copying trees --> only show highest level nodes as added)
  addedNodes = addedNodes.filter(({ pid }) => !addedNodes.find(({ id }) => id == pid));

  // remove any deleted nodes of which their parents are also deleted at this node map change
  // (e.g. when copying trees --> only show highest level nodes as deleted)
  deletedNodes = deletedNodes.filter(({ pid }) => !deletedNodes.find(({ id }) => id == pid));

  // describe added nodes
  addedNodes.forEach((addedNode) => {
    mapChangeDescription.icon = 'ri-add-box-fill';
    mapChangeDescription.descriptions.push({
      text: `Neuer Knoten`,
      preview: [
        { type: 'static', text: 'Eingefügt unter', fontStyle: 'italic' },
        { type: 'dynamic', text: addedNode.pid || '', fontStyle: 'italic' },
      ],
      details: [{ name: 'Eingefügt unter', value: addedNode.pid }],
    });
  });

  // describe updated nodes
  updatedNodes.forEach((nodeDiff) => {
    const sameParent = nodeDiff.prev.pid == nodeDiff.new.pid;
    if (sameParent) {
      // node's content has changed
      mapChangeDescription.icon = 'ri-paragraph';
      mapChangeDescription.descriptions.push({
        text: `Inhalt geändert`,
        preview: [
          { type: 'dynamic', text: nodeDiff.prev.id, textDecoration: 'line-through', fontStyle: 'italic' },
          { type: 'static', text: '➜' },
          { type: 'dynamic', text: nodeDiff.new.id, fontStyle: 'italic' },
        ],
        details: [
          { name: 'Alter Text', value: nodeDiff.prev.id },
          { name: 'Neuer Text', value: nodeDiff.new.id },
          { name: 'Neue Anhänge', value: 'TODO: Change content' },
          { name: 'Gelöschte Anhänge', value: 'TODO: Change content' },
          { name: 'Geänderte Anhänge', value: 'TODO: Change content' },
        ],
      });
    } else {
      // node was moved
      mapChangeDescription.icon = 'ri-drag-move-2-fill';
      mapChangeDescription.descriptions.push({
        text: `Knoten verschoben`,
        preview: [
          { type: 'dynamic', text: nodeDiff.new.id, fontStyle: 'italic' },
          { type: 'static', text: 'verschoben nach' },
          { type: 'dynamic', text: nodeDiff.new.pid || '', fontStyle: 'italic' },
        ],
        details: [
          { name: 'Text', value: nodeDiff.new.id },
          { name: 'Verschoben nach', value: nodeDiff.new.pid },
          { name: 'Verschoben von', value: nodeDiff.prev.pid },
        ],
      });
    }
  });

  // describe deleted nodes
  deletedNodes.forEach((deletedNode) => {
    mapChangeDescription.icon = 'ri-eraser-fill';
    mapChangeDescription.descriptions.push({
      text: `Knoten gelöscht`,
      preview: [
        { type: 'dynamic', text: deletedNode.id, fontStyle: 'italic' },
        { type: 'static', text: 'gelöscht.' },
      ],
      details: [{ name: 'Gelöschter Text', value: deletedNode.id }],
    });
  });

  return mapChangeDescription;
};
